import React, { useEffect, useState } from "react";
import { Box, Tooltip } from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "../../../utils/config";

// Customer side only: the stores MarketSync assigned to this customer, as small chips just before the profile icon.
const MAX = 3;

export default function NavStoreChips() {
  const token = useSelector((s) => s.auth.token);
  const [names, setNames] = useState([]);

  useEffect(() => {
    if (!token) return undefined;
    let off = false;
    axios.get(`${API_BASE_URL}/api/sellvia/store-names`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => {
        if (off) return;
        setNames((data?.companies || []).flatMap((c) => (c.stores || []).map((s) => s.store_name)).filter(Boolean));
      })
      .catch(() => {});
    return () => { off = true; };
  }, [token]);

  if (!names.length) return null;
  const shown = names.slice(0, MAX);
  const rest = names.slice(MAX);
  const chipSx = {
    px: 1.1, py: 0.35, borderRadius: "999px", fontSize: "0.72rem", fontWeight: 700, whiteSpace: "nowrap", maxWidth: 150,
    overflow: "hidden", textOverflow: "ellipsis", background: "#fbf5e6", border: "1px solid #efdfbd", color: "#7a5712",
  };
  return (
    <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 0.6, mr: 1.2, minWidth: 0 }}>
      {shown.map((n, i) => <Box key={`${n}-${i}`} sx={chipSx} title={n}>{n}</Box>)}
      {rest.length > 0 && (
        <Tooltip title={rest.join(", ")}><Box sx={{ ...chipSx, background: "#e9e1cd", color: "#5d5546" }}>+{rest.length}</Box></Tooltip>
      )}
    </Box>
  );
}
